import { useRef, useCallback, useEffect } from 'react';

type IDebounceContext = {
  fn: Function;
  timer: number | null;
};

const useDebounce = (fn: Function, delay = 300, depths: React.DependencyList = []): Function => {
  const { current } = useRef<IDebounceContext>({ fn, timer: null });

  useEffect(() => {
    current.fn = fn;
  }, [fn]);

  return useCallback((...args: any[]) => {
    if (current.timer) {
      clearTimeout(current.timer);
    }
    current.timer = setTimeout(() => {
      current.fn.call(this, ...args);
      current.timer = null;
    }, delay) as any;
  }, depths);
};

export default useDebounce;
